import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ButtonModule, DialogModule, DropdownModule, PaginatorModule } from 'primeng';
import { RouteRecommendationService } from '../../../../../services/route-recommendation.service';
import { ActivatedRoute } from '@angular/router';
import { IRouteRecommendationItinerary } from '../../../../../interfaces/route-recommendations/route-recommendation-itinerary';
import { IRouteRecommendationAlternateDate } from '../../../../../interfaces/route-recommendations/route-recommendation-alternate-date';
import { VmePipesModule } from '../../../../../vme-pipes.module';
import { CommonModule } from '@angular/common';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-route-itinerary-confirm-start-date',
  templateUrl: './route-itinerary-confirm-start-date.component.html',
  styleUrls: ['./route-itinerary-confirm-start-date.component.css'],
  imports: [
    DialogModule,
    ButtonModule,
    DropdownModule,
    PaginatorModule,
    VmePipesModule,
    CommonModule,
  ],
  standalone: true,
})
export class RouteItineraryConfirmStartDateComponent implements OnInit {
  @Input() showConfirmStartDateDialog: boolean;
  @Output() showConfirmStartDateDialogChange: EventEmitter<boolean> = new EventEmitter();

  @Output() selectedDateChange: EventEmitter<number> = new EventEmitter();

  @Output() grabOrDeployClicked = new EventEmitter<void>();

  @Input() routeId: number;

  @Input() isVME: boolean = false;

  @Input() supplierName: string;

  routes: IRouteRecommendationAlternateDate[];

  protected selectedRoute: IRouteRecommendationAlternateDate;

  protected dateSelectItems: SelectItem[];

  constructor(private routeRecommendationService: RouteRecommendationService) {}

  ngOnInit(): void {
    this.routeRecommendationService.getItineraryAlternateDates(this.routeId).then((dates) => {
      this.routes = dates;
      this.dateSelectItems = dates.map((x) => ({
        label: x.label,
        value: x,
      }));
      this.selectedRoute = dates.find((x) => x.id === this.routeId);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['routeId'] && !changes['routeId'].firstChange) {
      this.selectedRoute = this.routes.find((x) => x.id === this.routeId);
    }
  }

  onRouteDateChange(selectedRouteObj: IRouteRecommendationAlternateDate) {
    this.selectedDateChange.emit(selectedRouteObj.id);
  }
}
